import { React, useState } from 'react'
import { Link } from 'react-router-dom'
import { Dropdown } from 'react-bootstrap'
import { IoIosArrowUp } from 'react-icons/io'
import { IoIosArrowDown } from 'react-icons/io'

function FarmsBox() {

    const [Accordian1, setAccordian1] = useState(0)

    return (
        <div className="col-lg-6 p-1">
            <div className="card g-card farms-card p-lg-3 p-2">
                <div className="card-body ">
                    <div className="row   mx-0 farms-row ">
                        <div className="d-flex justify-content-between">
                            <div className=" pb-lg-0 pb-3 d-flex align-items-start">
                                <img src={process.env.PUBLIC_URL + "/assets/images/binance.png"} className="logo" alt="" />
                                <div className="d-flex flex-column ps-3">
                                    <h5 className="text-uppercase farms-heading fw-600">reaper-busd</h5>
                                    <div className=" d-lg-flex d-none ">
                                        <div className="d-flex flex-column align-items-start">
                                            <span className="text-faded text-small text-uppercase">yrp earned</span>
                                            <h5 className="text-uppercase fs-6"><span className="text-success fs-6">$ </span> 30</h5>
                                        </div>
                                        <div className="d-flex flex-column align-items-center ps-3">
                                            <span className="text-faded text-small text-uppercase">staked</span>
                                            <h5 className="text-uppercase fs-6"><span className="text-success fs-6">$ </span> 150</h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className=" row mx-0">
                                    <div className="col-6 px-0 d-flex flex-column">
                                        <span className="text-faded  text-uppercase  d-flex">apy : </span>
                                        <span className="text-faded  text-uppercase  d-flex">apr : </span>
                                        <span className="text-faded  text-uppercase  d-flex">daily: </span>
                                    </div>
                                    <div className="col-6">
                                        <span className="  text-uppercase d-flex justify-content-end">150%</span>
                                        <span className="  text-uppercase d-flex justify-content-end">150%</span>
                                        <span className="  text-uppercase d-flex justify-content-end">150%</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className=" d-lg-none d-flex col-12  ">
                            <div className="d-flex flex-column align-items-start">
                                <span className="text-faded text-small text-uppercase">yrp earned</span>
                                <h5 className="text-uppercase fs-6"><span className="text-success fs-6">$ </span> 30</h5>
                            </div>
                            <div className="d-flex flex-column align-items-center ps-3">
                                <span className="text-faded text-small text-uppercase">staked</span>
                                <h5 className="text-uppercase fs-6"><span className="text-success fs-6">$ </span> 150</h5>
                            </div>
                        </div>
                        <div className="col-12 row px-0 mx-0 pt-3 pb-3 ">
                            <div className="col-8 px-0 row mx-0">
                                <div className="col-lg-8 col-6 ps-0 ">
                                    <button className="harvest w-100">Compound</button>
                                </div>
                                <div className="col-lg-4 col-6 pe-0 d-flex ">
                                    <button className="harvest w-100">Harvest</button>
                                </div>
                            </div>
                            <div className="col-4 d-flex align-items-center justify-content-end">
                                <span className="text-faded pointer" onClick={() => { Accordian1 == 1 ? setAccordian1(0) : setAccordian1(1) }}>   {Accordian1 == 1 ? <>  Hide  <IoIosArrowUp className="text-faded" /></> : <>Details <IoIosArrowDown className="text-faded" /></>} </span>
                            </div>
                        </div>
                    </div>
                    {Accordian1 == 1 &&
                        <>
                            <div className="d-flex justify-content-between py-1   align-items-center  border-top pt-3">
                                <span className="text-faded text-small text-uppercase"> tvl</span>
                                <span className="  text-uppercase   "> $ 10,00,00 </span>
                            </div>
                            <div className="d-flex justify-content-between py-1   align-items-center  ">
                                <span className="text-faded text-small text-uppercase"> get lp</span>
                                <span className="  text-uppercase text-pink  "> reaper-busd</span>
                            </div>
                            <div className="d-flex justify-content-between py-1   align-items-center  ">
                                <span className="text-faded text-small text-uppercase"> multiplier</span>
                                <span className="  text-uppercase   ">20X </span>
                            </div>
                            <div className="d-flex justify-content-between py-1   align-items-center  ">
                                <span className="text-faded text-small text-uppercase"> staked value</span>
                                <span className="  text-uppercase   ">150$ </span>
                            </div>
                            <div className="d-flex justify-content-between py-1   align-items-center  ">
                                <span className="text-faded text-small text-uppercase"> earned value</span>
                                <span className="  text-uppercase   ">30$ </span>
                            </div>
                            <div className="d-flex justify-content-between   align-items-center  ">
                                <span className="text-faded text-small text-uppercase"> penalty 6%</span>
                                <div className="d-flex">
                                    <div className="d-flex flex-column  align-items-center ps-2">
                                        <span className="text-faded text-small text-uppercase"> days</span>
                                        <span className="  text-uppercase fs-6  "> 01 </span>
                                    </div>
                                    <div className="d-flex flex-column  align-items-center ps-2">
                                        <span className="text-faded text-small text-uppercase"> h</span>
                                        <span className="  text-uppercase fs-6  "> 02 </span>
                                    </div>
                                    <div className="d-flex flex-column  align-items-center ps-2">
                                        <span className="text-faded text-small text-uppercase"> m</span>
                                        <span className="  text-uppercase fs-6  "> 05 </span>
                                    </div>
                                </div>
                            </div>
                            <div className="d-flex justify-content-between py-1   align-items-center  ">
                                <span className="text-faded text-small text-uppercase"> view contract</span>
                                <span className="  text-uppercase   ">add to meta mask </span>
                            </div>

                        </>
                    }

                </div>
            </div>
        </div>
    )
}

export default function Farms() {
    const [state, setstate] = useState(0)

    return (
        <div className="container pt-lg-5 pt-3">
            <div className="d-flex justify-content-center flex-lg-row flex-column align-items-lg-end">
                <div className="ws-stake-only me-lg-2">
                    <label className="switch">
                        <input type="checkbox" />
                        <span className="slider round"></span>
                    </label>
                    Staked Only
                </div>

                <div className="ws-tabs mt-lg-0 mt-2">
                    <Link to='/farms' className={state == 1 ? "active col text-center" : " col text-center"} onClick={() => { setstate(1) }}>Active</Link>
                    <Link to='/farms' className={state == 0 ? "active col text-center" : " col text-center"} onClick={() => { setstate(0) }}>Inactive</Link>
                </div>

                <div className="row mx-0">
                    <div className="col-6 px-0 pe-1">
                        <div className="stake-drop d-flex  flex-column ms-lg-2 mt-lg-0 mt-2">
                            {/* <span className="text-faded text-small py-2 ps-2">SORT</span> */}
                            <Dropdown>
                                <Dropdown.Toggle variant="dark" id="dropdown-basic">
                                    Newest
                                </Dropdown.Toggle>

                                <Dropdown.Menu>
                                    <Dropdown.Item href="#/action-1">Action</Dropdown.Item>
                                    <Dropdown.Item href="#/action-2">Another action</Dropdown.Item>
                                    <Dropdown.Item href="#/action-3">Something else</Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                    </div>
                    <div className="col-6 px-0 ps-1">
                        <div className="stake-search d-flex  flex-column ms-lg-2 mt-lg-0 mt-2">
                            {/* <span className="text-faded text-small py-2 ps-2">SEARCH</span> */}
                            <input type="text" placeholder="Search Pool..." />
                        </div>
                    </div>


                </div>


            </div>
            <div className="row mx-0 mt-4 justify-content-center">

                <FarmsBox />
                <FarmsBox />
                <FarmsBox />
                <FarmsBox />
                <FarmsBox />
                <FarmsBox />

            </div>
        </div>
    )
}
